const fetchOverlay = () => document.querySelector("#modal-overlay")

export const hideOverlay = ({ classes = ["z-10"] } = {}) => {
  const overlay = fetchOverlay()

  overlay.classList.add("hidden")
  document.body.style.overflow = ""
  classes.forEach((el) => overlay.classList.remove(el))
}

export const showOverlay = ({ classes = ["z-10"] } = {}) => {
  const overlay = fetchOverlay()

  overlay.classList.remove("hidden")
  document.body.style.overflow = "hidden"
  classes.forEach((el) => overlay.classList.add(el))
}
